
import { useUserStore } from "@/store/UserStore";
import { useThemeStore } from "@/store/ThemeStore";

import AuthMixin from '@/mixins/authMixin'
import UIMixin from '@/mixins/uiMixin'

export default {
    mixins: [AuthMixin, UIMixin],
    data () {
        const ThemeStore = useThemeStore();
        return {
            ThemeStore: ThemeStore,
            fetchingUser: true
        }
    },
    methods: {
        fetchUser(callback) {
            const canRedirect = !(this.$route.name == 'auth.signin')
            const client = this.ThemeStore.client
            const url = process.env.VUE_APP_BASE_URL + '/data/Scorm/Player?client=' + client
            const accessToken = this.$cookies.get('access_token')
            
            if (!accessToken && canRedirect) {
                this.$router.push({name: 'auth.signin'})
            }

            this.fetchingUser = true

            const headers = {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: 'Bearer ' + accessToken
            }

            this.$http.get(url, {headers: headers,}).then(
                res => {
                    const UserStore = useUserStore();
                    UserStore.setMessage(res.data.message)
                    UserStore.setAvatar(res.data.avatar)
                    UserStore.setFname(res.data.firstName)
                    UserStore.setLname(res.data.lastName)
                    UserStore.setLogin(res.data.login)
                    UserStore.setGroupLogo(res.data.groupLogo)
                    UserStore.setGroupName(res.data.groupName)
                    UserStore.setGroupCity(res.data.groupCity)
                    UserStore.setDocumentsToDownload(res.data.documentsToDownload)
                    UserStore.setLastConnectionDate(res.data.lastConnectionDate)
                    UserStore.setLastConnectionHour(res.data.lastConnectionHour)
                    UserStore.setPercentDone(res.data.percentDone)
                    UserStore.setCourseCategories(res.data.courseCategories)
                    UserStore.setStatistics(res.data.statistics)
                    UserStore.setPerformances(res.data.performances)
                    UserStore.setKpis(res.data.kpis)
                    UserStore.setTimeSpent(res.data.timeSpent)
                    UserStore.setLockedTrophiesCount(res.data.lockedTrophiesCount)
                    UserStore.setDocumentsCount(res.data.documentsCount)

                    const callbackType = typeof callback;
                    
                    this.fetchingUser = false

                    if (callbackType == 'function') {
                        callback()
                    }
                },
                error => {
                    this.fetchingUser = false

                    if (error.response.status == 401) {
                        this.refreshToken(() => {
                            this.fetchUser(callback)
                        })
                        
                        return
                    }
                }
            )
        },
    }
};